// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MS1jb","newExpiryDate":"styles_newExpiryDate__PqvdY","footer":"styles_footer__yDYOs"};